import React from "react";
import { DatePicker, ConfigProvider } from "antd";
import dayjs from "dayjs";

interface Props {
  startDate: string;
  endDate: string;
  onChangeStart: (value: string) => void;
  onChangeEnd: (value: string) => void;
  onApply: () => void;
  onClear: () => void;
  compact?: boolean;
  variant?: "dropdown" | "inline";
}

const DateRangeFilter: React.FC<Props> = ({
  startDate,
  endDate,
  onChangeStart,
  onChangeEnd,
  onApply,
  onClear,
  compact = false,
  variant = "dropdown",
}) => {
  // Render differently depending on variant
  if (variant === "inline") {
    const fromVal = startDate ? dayjs(startDate, "DD-MM-YYYY") : null;
    const toVal = endDate ? dayjs(endDate, "DD-MM-YYYY") : null;
    return (
      <div className="d-flex align-items-center gap-2 flex-wrap">
        <div style={{ minWidth: 150 }}>
          {/* <label className="form-label mb-1">From Date</label> */}
          <ConfigProvider>
            <DatePicker
              size="small"
              style={{ maxWidth: "150px", height: "31px" }}
              placeholder="From Date"
              format="DD-MM-YYYY"
              value={fromVal}
              onChange={(date) => onChangeStart(date ? dayjs(date).format("DD-MM-YYYY") : "")}
            />
          </ConfigProvider>
        </div>
        <div style={{ minWidth: 150 }}>
          {/* <label className="form-label mb-1">To Date</label> */}
          <ConfigProvider>
            <DatePicker
              size="small"
              style={{ maxWidth: "150px", height: "31px" }}
              placeholder="To Date"
              format="DD-MM-YYYY"
              value={toVal}
              onChange={(date) => onChangeEnd(date ? dayjs(date).format("DD-MM-YYYY") : "")}
              disabledDate={(current) => {
                if (!fromVal) return false;
                return current && current < fromVal.startOf("day");
              }}
            />
          </ConfigProvider>
        </div>
        <div className="d-flex gap-2" style={{ position: "relative", top: "-2px" }}>
          <button type="button" className="btn btn-info btn-sm" style={{ height: '31px', lineHeight: '1', padding: '0.25rem 0.75rem' }} onClick={onApply}>
            Search
          </button>
          <button type="button" className="btn btn-secondary btn-sm" style={{ height: '31px', lineHeight: '1', padding: '0.25rem 0.75rem' }} onClick={onClear}>
            Reset
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={compact ? "p-1" : "p-2"} style={{ minWidth: 260 }}>
      <div className="mb-2">
        <label className="form-label mb-1">Start Date</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={startDate}
          onChange={(e) => onChangeStart(e.target.value)}
          max={endDate || undefined}
        />
      </div>
      <div className="mb-2">
        <label className="form-label mb-1">End Date</label>
        <input
          type="date"
          className="form-control form-control-sm"
          value={endDate}
          onChange={(e) => onChangeEnd(e.target.value)}
          min={startDate || undefined}
        />
      </div>
      <div className="d-flex justify-content-end gap-2 mt-1">
        <button className="btn btn-sm btn-outline-secondary" onClick={onClear}>
          Clear
        </button>
        <button className="btn btn-sm btn-primary" onClick={onApply}>
          Apply
        </button>
      </div>
    </div>
  );
};

export default DateRangeFilter;
